import { Injectable } from '@angular/core';
import { ApplicationWidgetConfiguration, WidgetConfigurationManager } from '@ddv/widgets';

@Injectable()
export class DataService {
    getWidgetsForDashboard(): ApplicationWidgetConfiguration[] {
        return WidgetConfigurationManager.getWidgetsForDashboard();
    }
}
